
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"none","d":"M0 0h20v20H0V0z"}}),_c('path',{attrs:{"fill":"currentColor","d":"M11.7 1.7H3.3v16.7h13.3V6.7l-4.9-5zm-.8 1.2l4.6 4.6h-4.6V2.9zm-3 11.8H5.8V16H4.6v-4h3.3v2.7zm4.2.3c0 .6-.4 1-1.2 1H8.8v-4h2.1c.8 0 1.2.6 1.2 1v2zm3.5-2h-1.3v.7h1.2v1h-1.2V16H13v-4h2.6v1z"}}),_c('path',{attrs:{"fill":"currentColor","d":"M5.8 13h.9v.7h-.9zm4.2 0h.9v2H10z"}})])
          )
        }
      }
    